document.addEventListener('DOMContentLoaded', () => {
  const disableonsubmit = (event) => {
    const formElement = event.target;
    const submitElement = formElement.querySelector('.js-form-submit');
    submitElement.disabled = true;
  };

  document.querySelectorAll('.js-form-submit').forEach((submitElement) => {
    const formElement = submitElement.closest('form');
    formElement.addEventListener('submit', disableonsubmit);
  });
});
